import * as React from "react";
import { EPlatform } from "../api";

interface IPlatformContext {
  platform: EPlatform;
}
const PlatformContext = React.createContext<IPlatformContext>(null);

interface IPlatformProviderProps extends React.PropsWithChildren {
  platform: EPlatform;
}

export const PlatformProvider: React.FunctionComponent<IPlatformProviderProps> = ({ children, platform }) => {
  return <PlatformContext.Provider value={{ platform }}>{children}</PlatformContext.Provider>;
};

export const usePlatformContext = () => React.useContext(PlatformContext);
